(() => {
  const root = document.querySelector('[data-md-cart-root]');
  const dialog = root?.querySelector('dialog');
  if (!root || !dialog || !dialog.showModal || window.maisonBasket) return;
  const body = root.querySelector('[data-md-cart-body]');
  const status = root.querySelector('[data-md-cart-status]');
  const cartPath = root.dataset.cartUrl;
  const apiRoot = cartPath.replace(/cart\/?$/, '');
  let previousFocus;
  let busy = false;
  let revision = 0;
  let oldOverflow;
  const announce = message => { status.textContent = message; };
  const open = () => {
    if (!dialog.open) {
      previousFocus = document.activeElement;
      oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    }
  };
  const refresh = async () => {
    const requestRevision = ++revision;
    const url = new URL(cartPath, location.origin);
    url.searchParams.set('section_id', root.dataset.sectionId);
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(root.dataset.error);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const next = html.querySelector('[data-md-cart-body]');
    if (!next) throw new Error(root.dataset.error);
    if (requestRevision !== revision) return;
    body.innerHTML = next.innerHTML;
    const count = body.querySelector('[data-md-cart-count]')?.dataset.mdCartCount || '0';
    root.querySelector('[data-md-cart-badge]').textContent = count;
    document.querySelectorAll('.md-cart>span').forEach(node => { node.textContent = count; });
  };
  const run = async callback => {
    if (busy) return;
    busy = true;
    body.setAttribute('aria-busy', 'true');
    announce(root.dataset.loading);
    try {
      await callback();
      await refresh();
      announce(root.dataset.updated);
    } catch (error) {
      announce(error.message || root.dataset.error);
    } finally {
      busy = false;
      body.removeAttribute('aria-busy');
    }
  };
  const change = async (key, quantity, focusName) => {
    await run(async () => {
      const response = await fetch(apiRoot + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || root.dataset.error);
    });
    const line = [...body.querySelectorAll('[data-md-line]')].find(node => node.dataset.mdLine === key);
    (line?.querySelector(focusName) || root.querySelector('[data-md-close]')).focus();
  };
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = oldOverflow || '';
    previousFocus?.focus();
  });
  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
    const target = event.target.closest('button, a');
    if (!target) return;
    if (target.hasAttribute('data-md-close')) dialog.close();
    const line = target.closest('[data-md-line]');
    if (!line) return;
    const quantity = line.querySelector('[data-md-quantity]');
    if (target.hasAttribute('data-md-adjust')) {
      event.preventDefault();
      change(line.dataset.mdLine, Math.max(0, Number(quantity.value) + Number(target.dataset.mdAdjust)), '[data-md-quantity]');
    }
    if (target.hasAttribute('data-md-remove')) {
      event.preventDefault();
      change(line.dataset.mdLine, 0, '[data-md-quantity]');
    }
  });
  dialog.addEventListener('change', event => {
    if (!event.target.matches('[data-md-quantity]')) return;
    const value = Number(event.target.value);
    if (!Number.isInteger(value) || value < 0) { announce(root.dataset.error); return; }
    change(event.target.closest('[data-md-line]').dataset.mdLine, value, '[data-md-quantity]');
  });
  document.addEventListener('click', event => {
    const target = event.target.closest('a, button');
    if (!target || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const href = target.getAttribute('href');
    const isCart = href && new URL(href, location.origin).pathname.replace(/\/$/, '') === cartPath.replace(/\/$/, '');
    const nativeCart = target.getAttribute('on:click')?.includes('#cart-drawer/');
    if (!isCart && !nativeCart) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open();
    refresh().catch(() => announce(root.dataset.error));
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('.md-shop-card')) return;
    if (!form.action.includes('/cart/add')) return;
    event.preventDefault();
    if (busy) return;
    const formData = new FormData(form);
    formData.delete('return_to');
    open();
    run(async () => {
      const response = await fetch(apiRoot + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: formData });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || root.dataset.error);
    });
  });
  window.maisonBasket = {
    async onNativeAdd(event) {
      if (event.action !== 'add') return;
      try {
        const result = await event.promise;
        if (result?.detail?.didError) return;
        const otherModal = document.querySelector('dialog[open]:not(#md-basket-dialog)');
        if (otherModal) otherModal.addEventListener('close', () => { open(); refresh().catch(() => announce(root.dataset.error)); }, { once: true });
        else { open(); await refresh(); }
      } catch { announce(root.dataset.error); }
    }
  };
})();
